export default class ElementModel
{
    constructor(name, id, type, subtype, category, parameters, uuids, buildingstorey, mesh, meshuuid, fileName, fileId, filePathName, IFCSchema, fileuid, filetype, boundingbox, bvhnode)
    {
        this.name = name;
        this.id = id;  
        this.type = type;
        this.subtype = subtype
        this.category = category;
        this.parameters = parameters
        this.uuids = uuids;
        this.buildingstorey = buildingstorey;
        
        
        this.mesh = mesh;

        
        this.meshuuid = meshuuid;
        this.boundingBox = boundingbox
        this.bvhNode = bvhnode
        

        this.fileName = fileName;
        this.fileId = fileId;
        this.filePathName = filePathName;
        this.IFCSchema = IFCSchema;
        this.fileuid = fileuid;
        this.filetype = filetype;


    }
    
}